import react,{Component} from 'react';
import { DKLabel, DKButton,showToast,TOAST_TYPE, DKSpinner,DKCalendar,DKIcon,DKIcons,DKLine,DKInput,INPUT_VIEW_DIRECTION,Toggle, showLoader, removeLoader } from "deskera-ui-library";
import RouteManager from '../../../../managers/RouteManager';
import moment from 'moment';
import { INPUT_TYPE } from '../../../../constants/Constant';

import ReportService from '../../../../services/ReportService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../../../managers/TenantManagerService';
import i18next from 'i18next';
export default class WageRegisterReport extends Component{
    selectedUser = [];
    constructor(props){
        super(props)
        this.state = {
            loading:false,
            param: {
                month: moment().format('MMMM'),
                years: moment().year(),
                page: 1,
                limit: 20,
                employees: []
            }
        }
    }
    componentDidMount() {
        RouteManager.setPresenter(this);
    }

    export(){
        this.setState({...this.state,loading:true})
        
        let param = {
            month: moment.months().indexOf(this.state.param.month)+1,
            year: this.state.param.years
        }
        ReportService.downloadWageRegister(param).then(
            (response) => {
                this.setState({...this.state,loading:false})
                
                saveAs(response, `Wage_Register_Report_${this.state.param.month}_${this.state.param.years}.pdf`);
                showToast("Download completed", TOAST_TYPE.SUCCESS);
                
            }, async(error) => {
                showToast('Processed payrolls not found for the selected month and year',TOAST_TYPE.FAILURE);
                this.setState({...this.state,loading:false})
            }
        )
    }
    render(){
        return(
            <div className="parent-width">
                <DKLabel text="Wage Register Report" className="fw-m fs-l" />
                <div className="bg-white pb-l card-shadow mt-l">
                   <div className="d-flex">
                   <DKLabel text="Generate Wage Register Report" className="fw-m fs-l p-l" />
                   {this.state.loading && <DKSpinner/>}
                   </div>
                    
                    <DKLine  className="bg-gray3  "/>
                    <div className="d-flex mt-s row row-responsive">
                    <div className="p-h-l web-width-30 d-flex" >
                        <div className="web-width-70">
                            <DKInput
                                title={i18next.t("MONTH")}
                                value={this.state.param.month}
                                formatter={(obj) => {
                                    return obj;
                                }}
                                className=""
                                type={INPUT_TYPE.DROPDOWN}
                                showError={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={false}
                                required={true}
                                canValidate={true}
                                options={moment.months()}
                                onChange={(value,index) => {
                                   
                                    this.setState({
                                        ...this.state,
                                        param: {
                                            ...this.state.param,
                                            month: value,
                                            page: 1
                                        }
                                    })
                                }}
                                dropdownConfig={{

                                    data: moment.months(),
                                    renderer: (index, obj) => {
                                        return <DKLabel className="" text={obj} />;
                                    },
                                }}
                            />
                        </div>
                        <div className="web-width-70 ml-l">
                            <DKInput
                                title={i18next.t("YEAR")}
                                value={this.state.param.years}
                                formatter={(obj) => {
                                    return obj;
                                }}
                                className=""
                                type={INPUT_TYPE.DROPDOWN}
                                showError={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={false}
                                required={true}
                                canValidate={true}
                                options={[moment().year(), moment().subtract(1, 'years').year()]}
                                onChange={(value) => {
                                    this.setState({
                                        ...this.state,
                                        param: {
                                            ...this.state.param,
                                            years: value,
                                            page: 1
                                        }
                                    })

                                }}
                                dropdownConfig={{
                                    data: [moment().year(), moment().subtract(1, 'years').year()],
                                    renderer: (index, obj) => {
                                        return <DKLabel className="" text={obj} />;
                                    },
                                }}
                            />
                        </div>
                    </div>
                        <div className="d-flex web-width-15 justify-content-center " style={{marginTop: '20px'}}>
                        <DKButton
                            title="Download"
                            icon={DKIcons.white.ic_download}
                            className="bg-app text-white"
                            onClick={()=>{
                                this.export();
                            }}
                            />
                        </div>
                       
                    </div>
                </div>
            </div>
        )
    }
}
